import { Run } from "types/generated";

export const canDeprioritizeRun = (run: Run) => run.isPrioritized;

export const canPrioritizeRun = (run: Run, isPublicWorkerPool: boolean) =>
  !isPublicWorkerPool && !run.isPrioritized;
